import DealerInvitedListTable from './dealerInvitedListTable.container'

export default DealerInvitedListTable